module.exports = __webpack_public_path__ + "img/avatar-male.06b86b5f.png";